import HelpArticle, { type HelpArticleText } from "../HelpArticle";

// Run E2 J2: rewritten for Project Explore (K-5), English and Spanish.

const TEXT: Record<"en" | "es", HelpArticleText> = {
  en: {
    title: "Navigating the Dashboard",
    intro: "The menu on the left of your teacher dashboard has these pages. On a phone, open it with the menu button.",
    ordered: false,
    steps: [
      <><strong>Overview:</strong> choose a class to see a summary and a grade chart.</>,
      <><strong>Gradebook:</strong> each student's status and score on each assignment.</>,
      <><strong>Assignments:</strong> the chapters you have assigned.</>,
      <><strong>Student Progress:</strong> each student's average score and a status label from it, with their last submission and last login.</>,
      <><strong>Class Management:</strong> add classes and students.</>,
      <><strong>Grade Scales:</strong> set how scores become grades.</>,
    ],
    tip: "The Assign PE Chapter button at the top of the dashboard assigns a chapter to a class or to some students.",
  },
  es: {
    title: "Cómo usar el panel",
    intro: "El menú a la izquierda de tu panel de maestro tiene estas páginas. En un teléfono, ábrelo con el botón del menú.",
    ordered: false,
    steps: [
      <><strong>Resumen:</strong> elige una clase para ver un resumen y una gráfica de calificaciones.</>,
      <><strong>Calificaciones:</strong> el estado y el puntaje de cada estudiante en cada tarea.</>,
      <><strong>Tareas:</strong> los capítulos que asignaste.</>,
      <><strong>Progreso de los estudiantes:</strong> el puntaje promedio de cada estudiante y una etiqueta de estado según ese promedio, con su última entrega y su último inicio de sesión.</>,
      <><strong>Administrar clases:</strong> agrega clases y estudiantes.</>,
      <><strong>Escalas de calificación:</strong> define cómo los puntajes se convierten en calificaciones.</>,
    ],
    tip: "El botón Asignar un capítulo, arriba en el panel, asigna un capítulo a una clase o a algunos estudiantes.",
  },
};

export default function NavigatingTheDashboard() {
  return <HelpArticle text={TEXT} />;
}
